import {
  ChangeDetectionStrategy,
  Component,
  HostListener,
  Input
} from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ComponentCanDeactivate } from '@check-list/app/classes/component-can-deactivate';
import { TranslocoService } from '@ngneat/transloco';
import { NzModalService } from 'ng-zorro-antd/modal';
import { Observable } from 'rxjs';

@Component({
  selector: 'authority-labs-base-dialog',
  templateUrl: './base-dialog.component.html',
  styleUrls: ['./base-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BaseDialogComponent extends ComponentCanDeactivate {
  @Input() dialogRef: MatDialogRef<unknown, unknown>;
  @Input() title: string;
  @Input() icon: string;
  @Input() isDirty = false;
  @Input() returnedData: unknown;
  @Input() size: 'default' | 'large' = 'default';
  @Input() contentStyle = '';

  get isLargeDialog(): boolean {
    return this.size === 'large';
  }

  constructor(
    private readonly modal: NzModalService,
    private readonly translocoService: TranslocoService,
    private dialog: MatDialog
  ) {
    super();
  }

  @HostListener('window:beforeunload', ['$event'])
  public unloadNotification($event: { returnValue: boolean }) {
    if (!this.canDeactivate()) {
      $event.returnValue = true;
    }
  }

  canDeactivate(): Observable<boolean> | boolean {
    return !this.isDirty;
  }

  close(): void {
    if (this.isDirty) {
      this.modal.confirm({
        nzTitle: this.translocoService.translate('dialogs.confirm.exit.title'),
        nzContent: this.translocoService.translate(
          'dialogs.confirm.exit.content'
        ),
        nzOnOk: () => this.dialogRef.close(this.returnedData)
      });
    } else {
      this.dialogRef.close(this.returnedData);
    }
  }
}
